import CircularProgress from "@mui/material/CircularProgress";
import { formatCurrency } from "@/main/services/utilsNumber";
import { EMPTY_VALUE, getRefundTotalLabel } from "@/main/screens/order/refunds/refundsScreenUtils";
import * as S from "./styles";

type IRefundsTotalCard = {
	idVoucherRefundStatus: number | undefined;
	totalAmount: number | null;
	isLoading: boolean;
};

export default function RefundsTotalCard({
	idVoucherRefundStatus,
	totalAmount,
	isLoading,
}: Readonly<IRefundsTotalCard>) {
	const hasTotal = totalAmount !== null;

	function renderValue() {
		if (isLoading) return <CircularProgress size={16} />;
		return hasTotal ? formatCurrency(totalAmount) : EMPTY_VALUE;
	}

	return (
		<S.Card id="id-refunds-card-total">
			<S.Label>{getRefundTotalLabel(idVoucherRefundStatus)}</S.Label>
			<S.Value $hasTotal={hasTotal} id="id-refunds-card-total-value">
				{renderValue()}
			</S.Value>
		</S.Card>
	);
}
